import type { OnboardingExperience } from './onboardingSelections';

export type OnboardingExperienceOffer = 'course' | 'community';

const EXPERIENCE_OFFERS: Record<
  OnboardingExperience,
  OnboardingExperienceOffer
> = {
  starting_from_zero: 'course',
  started_not_monetizing: 'course',
  experienced_with_clips: 'community',
  monetizing_clipping_channel: 'community',
};

export function resolveExperienceOffer(
  experience: OnboardingExperience,
): OnboardingExperienceOffer {
  return EXPERIENCE_OFFERS[experience];
}
